<template>
  <v-app>
    <core-drawer />

    <core-view />
  </v-app>
</template>

<script>
export default {
  components: {
    CoreDrawer: () => import('@/components/core/Drawer'),
    CoreView: () => import('@/components/core/View'),
  },
};
</script>

<style>
/*@media (min-width: 1264px) {
  .container {
    max-width: 1400px;
  }
}*/
@media print {
  .v-navigation-drawer {
    display: none;
  }
}
</style>
